export enum OrgStatus {
  Active = 'active',
  Inactive = 'inactive',
}

export enum OrgType {
  Internal = 'internal',
  Customer = 'customer',
  Prospect = 'prospect',
}

export type OrgMetadata = {
  organization: string
  status: string
  type: string
  org_name: string
}

export const defaultOrgMetadata: OrgMetadata = {
  organization: '',
  status: '',
  type: '',
  org_name: '',
}
